<template>
  <div>
    <div class="ui search" ref="search">
      <div class="ui left icon action input">
        <input
          class="prompt"
          type="text"
          :value="staff_name"
          style="max-width: 84%"
        />
        <i class="search icon"></i>
        <div class="ui red right icon button" @click="clean">
          <i class="eraser icon"></i>
        </div>
      </div>
    </div>
    <div class="ui card" v-if="staff && staff.uuid">
      <div class="content">
        <a class="header">{{ staff_name }}</a>
        <div class="description">
          <p>
            {{ $t("job position") }}
            <strong>{{ staff.multimoney_staff_job_position.name }}</strong>
          </p>
          <div class="ui list">
            <div class="item">
              {{ $t("admission date") }}
              <strong>{{ staff.admission_date }}</strong>
            </div>
            <div class="item">
              {{ $t("id number") }} <strong>{{ staff.id_number }}</strong>
            </div>
            <div class="item">
              {{ $t("soc") }} <strong>{{ staff.soc_user }}</strong>
            </div>
            <div class="item">
              {{ $t("core sys") }} <strong>{{ staff.core_sys_user }}</strong>
            </div>
            <div class="item">
              {{ $t("ucontact") }} <strong>{{ staff.ucontact_user }}</strong>
            </div>
            <div class="item">
              {{ $t("printing") }} <strong>{{ staff.printing_user }}</strong>
            </div>
            <div class="item" v-if="staff.usr_user">
              {{ $t("modul") }}
              <strong>{{ staff.usr_user.username }}</strong>
            </div>
            <div class="item" v-else>
              <i class="red remove icon"></i> {{ $t("modul") }}
            </div>
            <div class="item">
              {{ $t("status") }}
              <strong>{{ staff.multimoney_staff_status.name }}</strong>
            </div>
            <div class="item">
              {{ $t("area") }}
              <strong>{{ staff.multimoney_staff_area.name }}</strong>
            </div>
            <div class="item">
              {{ $t("country") }}
              <strong>{{ staff.multimoney_staff_country.name }}</strong>
            </div>
            <div class="item">
              {{ $t("grouper") }}
              <strong>{{ staff.multimoney_staff_grouper.name }}</strong>
            </div>
            <div class="item">
              {{ $t("team") }}
              <strong>{{ staff.multimoney_staff_team.name }}</strong>
            </div>
          </div>
          <!-- <pre>{{ staff }}</pre> -->
        </div>
      </div>
    </div>
    <div class="ui positive message" v-else>
      <div class="content">
        <div class="header">{{ $t("not set") }}</div>
        <p>{{ $t("staff has not been set yet") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import filters from "@/filters";

// @ is an alias to /src
export default {
  name: "StaffSearch",
  components: {},
  props: {},
  filters: filters,
  data() {
    return {
      staff: {},
    };
  },
  computed: {
    staff_name() {
      let vm = this;
      if (vm.staff && vm.staff.uuid) {
        return `${vm.staff.first_name} ${vm.staff.surname}`;
      } else return "";
    },
  },
  methods: {
    clean() {
      // console.log("cleaning staff search");
      this.$emit("clear");
      this.staff = {};
    },
    set_staff(staff_id) {
      let vm = this;
      local_api(
        vm,
        "post",
        "/multimoney_staff/organization/do-get-staff-by-id",
        {
          u: staff_id,
        },
      )
        .then((response) => {
          vm.staff = response;
          vm.$emit("selected", response);
        })
        .catch((err) => {
          error_toast(err);
        })
        .finally(() => {
          vm.processing = false;
        });
    },
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.search).search({
      apiSettings: {
        action: "search multimoney staff",
        beforeXHR: function (xhr) {
          let token = vm.$session.get("token");
          if (token) {
            xhr.setRequestHeader("x-access-token", token);
          }

          return xhr;
        },
        onResponse: function (response) {
          if (!response.success) error_toast(response.error);
          else {
            var _response = {
              results: [],
            };
            response.data.map((r) => {
              let name = "";
              if (r.first_name) name += r.first_name;
              if (r.second_name) name += ` ${r.second_name}`;
              if (r.surname) name += ` ${r.surname}`;
              if (r.second_surname) name += ` ${r.second_surname}`;

              _response.results.push({
                title: name,
                description: r.create_date,
                staff: r,
              });
            });
            // _response.results.push({
            //   title: vm.$t("new"),
            //   description: vm.$t("new customer"),
            //   customer: "NEW",
            // });
            return _response;
          }
        },
      },
      onSelect(result) {
        local_api(vm, "post", "/multimoney_staff/organization/do-get-staff", {
          u: result.staff.uuid,
        })
          .then((response) => {
            vm.staff = response;
            vm.$emit("selected", response);
          })
          .catch((err) => {
            error_toast(err);
          })
          .finally(() => {
            vm.processing = false;
          });
      },
    });
  },
  watch: {},
};
</script>
